import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedDataService } from '../../shared/shared-data-service';

@Component({
  selector: 'data-preview-component',
  templateUrl: './data-preview.component.html',
  styleUrls: ['./data-preview.component.scss'],
})
export class DataPreviewComponent implements OnInit, OnDestroy {
  showBackToNewTask = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<DataPreviewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedData: SharedDataService
  ) {}

  ngOnInit(): void {
    this.sharedData.getData().subscribe((data) => {
      this.showBackToNewTask = !!data?.fromNewTask;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
  
  ngOnDestroy(): void {  
    this.sharedData.setData({ fromNewTask: false });
  }
}
